import QualityIndicatorList from './quality-indicator-list';

export default {
  init: function (selector) {
    const qualityIndicatorLists = document.querySelectorAll(selector);

    if (qualityIndicatorLists && qualityIndicatorLists.length) {
      [...qualityIndicatorLists].map(item => {
        const qualityIndicatorList = new QualityIndicatorList(item);
        qualityIndicatorList.init();
      });
    }
  }
};
